import React, { memo, FC, useMemo, useCallback } from 'react';
import classNames from 'classnames';
import {
  Button,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  makeStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';
import { ChevronDown20Regular } from '@fluentui/react-icons';

export const useStyles = makeStyles({
  dropdown: {
    ...shorthands.flex(0, 0, 'auto'),
    alignSelf: 'start',
  },
  dropdownTriggerButton: {
    ...shorthands.padding('0px', '0px', '3px', '0px'),
    width: '20px',
    height: '20px',
    minWidth: '20px',
    ':active': { backgroundColor: tokens.colorNeutralStroke1Hover },
    ':hover': { backgroundColor: tokens.colorNeutralStroke1Hover },
  },
});

export interface IMetricPickerMenuButtonProps {
  dropdownMetrics: Array<{
    key: string,
    displayName: string,
  }>;
  onMetricDropdownSelect: (key: string) => void;
}

export const MetricPickerMenuButton: FC<IMetricPickerMenuButtonProps>
  = memo(({ dropdownMetrics, onMetricDropdownSelect }: IMetricPickerMenuButtonProps) => {
    const classes = useStyles();

    const dropdownItems = useMemo(() => dropdownMetrics.map((metric) => {
      const handleDropdownSelect = (e) => {
        onMetricDropdownSelect(metric.key);
        e.stopPropagation();
      };
      return (
        <MenuItem
          key={metric.key}
          onClick={handleDropdownSelect}
          className="ba-metric-picker-menu-button-item"
        >
          {metric.displayName}
        </MenuItem>
      );
    }), [dropdownMetrics, onMetricDropdownSelect]);

    // we have to do this because the parent element is the table header cell, which will re-order table when clicked
    const onMenuClick = useCallback((e) => {
      e.stopPropagation();
    }, []);

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div className={classNames('ba-metric-picker-menu-button', classes.dropdown)} onClick={onMenuClick}>
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <Button className={classNames('ba-metric-picker-menu-button-trigger', classes.dropdownTriggerButton)} appearance="subtle" icon={<ChevronDown20Regular />} />
          </MenuTrigger>
          <MenuPopover>
            <MenuList className="ba-metric-picker-menu-button-list">
              {dropdownItems}
            </MenuList>
          </MenuPopover>
        </Menu>
      </div>
    );
  });
